module.exports = __webpack_public_path__ + "static/media/step_001.71152086.jpeg";